<template>
  <v-container class="pt-0">
    <v-form ref="paymentForm" v-model="valid">
      <v-card elevation="0" class="d-flex justify-center">
        <v-card-title style="word-break: break-word" class="text-lg py-0"
          >Tuition Fee Advance Payment</v-card-title
        >
      </v-card>

      <v-alert v-if="payment_status === '0399'" dense type="error" class="mt-2">
        Your payment has failed. Please check your payment details and try
        again. If the issue persists, contact your bank or our support team.
      </v-alert>
      <v-alert
        v-else-if="payment_status === '0002'"
        dense
        type="info"
        class="mt-2"
      >
        Your payment is pending. Check your payment status after some time with
        your Unique ID.
      </v-alert>
      <v-alert
        v-else-if="payment_status === 'NOT RECEIVED'"
        dense
        type="info"
        class="mt-2"
      >
        Your payment is pending. Check your payment status after some time with
        your Unique ID.
      </v-alert>

      <v-row dense class="mt-2 gap-3">
        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Name
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ form.name || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Email
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ form.email || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              DOB
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ formatDateForDisplay || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Mobile
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ form.mobile_prefix }} {{ form.mobile_no || "..." }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Batch
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{
                form.year && form.batch ? `${form.year} - ${form.batch}` : "..."
              }}
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" class="py-1 px-1">
          <v-card class="pa-3 rounded-lg" outlined height="100%">
            <div
              class="text-caption font-weight-medium grey--text text--darken-1"
            >
              Programme
            </div>
            <div
              class="text-body-1 font-weight-bold grey--text text--darken-3 mt-1"
            >
              {{ program_name || "..." }}
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" sm="4" class="py-2 px-3">
          <v-card
            class="pa-0 d-flex align-middle" style="min-height: 120px;"
          >
            <v-card-text
              class="text--primary d-flex flex-column justify-center"
              style="z-index: 2"
            >
              <div class="d-flex justify-space-between text-caption" v-if="form.application_fee_amount > 0">
                <div class="font-weight-medium">Application Fee:</div>
                <div class="font-weight-bold">
                  ₹{{ form.application_fee_amount || "0.00" }}
                </div>
              </div>
              <div class="d-flex justify-space-between text-caption" v-if="form.advance_fee_amount > 0">
                <div class="font-weight-medium">Tuition Fee Advance:</div>
                <div class="font-weight-bold">
                  ₹{{ form.advance_fee_amount || "0.00" }}
                </div>
              </div>
              <v-divider v-if="form.application_fee_amount > 0 || form.advance_fee_amount > 0" class="my-3"></v-divider>
              <div
                class="d-flex justify-space-between text-body-1 font-weight-semi-bold"
              >
                <strong>{{
                  payment_status === "0300"
                    ? "Amount Paid:"
                    : "Amount to be Paid:"
                }} <v-icon v-if="payment_status === '0300'" class="primary--text">mdi-checkbox-multiple-marked-circle</v-icon></strong>
                <span class="font-weight-bold">  ₹{{ amount_to_pay ? amount_to_pay : "0.00" }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="pt-3 d-flex justify-center pl-4">
        <span class="text-caption font-weight-bold"
          >Disclaimer: Upon successful application, the fee will be applied to
          tuition fee and balance to be paid; otherwise, it will be refunded.
        </span>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex justify-center align-center gap-4">
          <v-btn
            v-if="payment_status === '0399' || !payment_status"
            :disabled="!valid"
            color="error"
            @click="redirectToHome"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="payment_status === '0300'"
            color="error"
            @click="redirectToHome"
          >
            Back
          </v-btn>
          <v-btn
            v-if="payment_status"
            class="ml-2"
            color="success"
            @click="showPaymentDialog = true"
          >
            Check payment status
          </v-btn>
          <v-btn
            class="ml-2"
            v-if="paymentEnabled && (payment_status === '0399' || !payment_status)"
            :disabled="!valid"
            color="success"
            :loading="loading"
            @click="pay"
          >
            <v-icon small class="mr-2">mdi-lock</v-icon> Pay Now
          </v-btn>
          <v-btn
            class="ml-2"
            v-if="payment_status === '0300'"
            :disabled="!valid"
            color="success"
            :loading="loading"
            @click="navigateToApplication"
          >
            Proceed
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="pa-2">
        <v-card-title>Unique ID </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="unique_id"
            required
            hide-details="auto"
            outlined
            dense
            :rules="[rules.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-2" @click="redirectToHome">
            Cancel
          </v-btn>
          <v-btn
            :disabled="!unique_id"
            color="success"
            class="mr-2"
            @click="proceedUniqueID"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPaymentDialog" max-width="520px" persistent>
      <v-card class="px-4 rounded-xl elevation-12" ref="downloadContent">
        <v-card-title
          class="text-body-1 text-3xl font-weight-bold text-primary"
        >
          Payment Summary
          <v-btn
            v-if="payment_status !== '0399'"
            x-small
            fab
            class="ml-2 mt-1"
            text
            ><v-icon @click="downloadAsTextFile" class="primary--text" small
              >mdi-download</v-icon
            ></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn icon large @click="showPaymentDialog = false">
            <v-icon small color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-3">
          <v-simple-table
            dense
            class="text-caption"
            v-if="payment_status !== '0399'"
          >
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Application ID</td>
                  <td>{{ form.application_id || "-" }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">DOB</td>
                  <td>{{ form.dob ? formatDateForDisplay : "-" }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Mobile Number</td>
                  <td>{{ form.mobile_no }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Program</td>
                  <td>{{ program_name }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table dense class="text-caption pb-3 pt-3">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Bank Ref. No</td>
                  <td>{{ payment_order_status.bank_ref_no }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Bank ID</td>
                  <td>{{ payment_order_status.bankid }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Charge Amount</td>
                  <td>{{ payment_order_status.charge_amount }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Mode</td>
                  <td>
                    {{
                      payment_order_status.payment_method_type
                        .charAt(0)
                        .toUpperCase() +
                      payment_order_status.payment_method_type.slice(1)
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Payment Status</td>
                  <td
                    :class="{
                      'error--text':
                        payment_order_status.auth_status === '0399' ||
                        payment_order_status.auth_status === 'NOT RECEIVED',
                      'warning--text':
                        payment_order_status.auth_status === '0002',
                      'success--text':
                        payment_order_status.auth_status !== '0399' &&
                        payment_order_status.auth_status !== '0002' &&
                        payment_order_status.auth_status !== 'NOT RECEIVED',
                    }"
                  >
                    {{
                      payment_order_status.auth_status === "0300"
                        ? "Success"
                        : payment_order_status.auth_status === "0399"
                        ? "Failed"
                        : payment_order_status.auth_status === "0002"
                        ? "Pending"
                        : payment_order_status.auth_status === "NOT RECEIVED"
                        ? "Amount not received"
                        : payment_order_status.auth_status
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction Status</td>
                  <td>{{ payment_order_status.transaction_error_desc }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction ID</td>
                  <td>
                    {{ payment_order_status.transactionid }}
                    <v-btn
                      icon
                      small
                      @click="
                        copyToClipboard(payment_order_status.transactionid)
                      "
                    >
                      <v-icon small class="ml-1">mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold pr-4 pl-0">Transaction Date</td>
                  <td>
                    {{ payment_order_status.transaction_date }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <span
            v-if="payment_status === '0300'"
            class="py-3 text-caption break-all text-caption font-weight-bold"
          >
            Note: Payment details sent via email. Please proceed to the next
            step to complete your application.
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { rules } from "@/helpers/rules";
import env from "@/helpers/env";
import { fetchPaymentEnabled } from "@/helpers/paymentAvailability";
export default {
  data() {
    return {
      rules,
      valid: true,
      form: {
        program_id: null,
        schedule: {},
      },
      unique_id: null,
      dialog: false,
      programs: [],
      payment_status: null,
      showPaymentDialog: false,
      payment_order_status: {},
      loading: false,
      amount_to_pay: null,
      env: env,
      paymentEnabled: false,
      program: null,
    };
  },
  async created() {
    fetchPaymentEnabled(this.$axios).then((enabled) => (this.paymentEnabled = enabled));
    const { unique_id, status, order_id } = this.$route.query;
    this.payment_status = status;
    this.unique_id = unique_id;

    if (unique_id) {
      await this.getApplicant(unique_id);
    } else {
      this.dialog = true;
    }

    if (order_id) {
      await this.updatePreApplicant(order_id);
      await this.getPaymentOrder(order_id);
    }
    if (status === "0300") {
      this.$store.commit("showSnackbar", {
        message: "Payment successfully completed",
        color: "success",
        timeout: 5000,
      });
      this.showPaymentDialog = true;
    }
  },
  computed: {
    formatDateForDisplay() {
      if (!this.form.dob) return "";
      const [year, month, day] = this.form.dob.split("-");
      return `${day}-${month}-${year}`;
    },
    program_name() {
      const baseName = this.program?.degree?.short_name || "";
      if (!baseName) {
        return "";
      }
      const specialization = this.program?.specialization || "";
      return baseName + (specialization ? " - " + specialization : "");
    },
  },
  methods: {
    async getApplicant() {
      if (!this.unique_id) return;
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `/get_pre_application_by_unique_id/${this.unique_id}`
        );
        this.form = response.data.data;
        this.amount_to_pay = this.form.amount_to_pay;
        this.getProgramName();
        if(this.amount_to_pay <= 0) {
          this.$router.push({
          path: "/home",
          query: {
            application_id: this.form.application_id,
            dob: this.formatDateForDisplay,
          },
        });
        }
        else if(this.form.application_id) {
          const paymentResponse = await this.$axios.get(
            `/get_pre_application_fee_payments_by_application_id/${this.form.application_id}`
          );
          const payments = paymentResponse.data.data;
          await this.getPaymentOrder(payments.order_id);
        }

        this.dialog = false;
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    async updatePreApplicant(orderid) {
      this.form.payment_order_id = orderid;
      this.getPaymentOrder(orderid);
      await this.$axios
        .put(`/pre_applications/${this.form.id}`, {
          pre_application: this.form,
        })
        .then(() => {
          console.log("payment order updated for pre applicant");
        });
    },
    redirectToHome() {
      this.$router.push("/registration");
    },
    showQuery() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          unique_id: this.unique_id,
        },
      });
    },
    async proceedUniqueID() {
      this.showQuery();
      await this.getApplicant();
    },
    async getPaymentOrder(orderid) {
      await this.$axios.get("/get_payment_order/" + orderid).then((res) => {
        this.payment_order_status = res.data.data;
        this.payment_status = this.payment_order_status.auth_status;
      });
    },
    async getProgramName() {
      await this.$axios.get(`/programs/${this.form.program_id}`).then((res) => {
        this.program = res.data.data;
      });
    },
    getFixedAmount(type) {
      const fee = parseFloat(this.form.amount_to_pay);
      if (isNaN(fee)) return "0.00";
      if (type == "Direct") return fee.toFixed(2);
      if (type == "Split") return fee.toFixed(2);
    },

    getPaymentPayload() {
      return {
        mercid: this.env.merchantid,
        amount: this.getFixedAmount("Direct"),
        return_url: this.env.pre_app_fee_ru,
        additional_info: {
          additional_info1: this.unique_id,
          additional_info2: this.form.email,
          additional_info3: "Tuition fee Advance Payment",
          additional_info4: "NA",
          additional_info5: "NA",
          additional_info6: "NA",
          additional_info7: "NA",
        },
        split_payment: this.env.getSplitPayment(this.form.amount_to_pay),
      };
    },
    async createBilldeskHistory(order_id, ecom_order_id, order_ref_no) {
      const data = {
        order_id: order_id,
        ecom_order_id: ecom_order_id,
        order_ref_no: order_ref_no,
        name: this.form.name,
        email: this.form.email,
        unique_id: this.unique_id,
        mobile_no: this.form.mobile_no,
        program_id: String(this.form.program_id),
        amount: this.form.amount_to_pay,
        current_status: "initiated",
        fee_type: "Tuition Fee Advance",
      };
      await this.$axios
        .post(`/billdesk_track_history`, { billdesk_track_history: data })
        .then((res) => {
          console.log("saved history");
        });
    },
    async pay() {
      await this.getApplicant();
      if (this.form.application_id) {
        this.$store.commit("showSnackbar", {
          message: "Payment already completed",
          color: "success",
          timeout: 5000,
        });
        this.$router.push({
          path: "/home",
          query: {
            application_id: this.form.application_id,
            dob: this.formatDateForDisplay,
          },
        });
        return;
      }
      this.$store.commit("showSnackbar", {
        message: "Redirecting to payment gateway...",
        color: "info",
      });
      this.loading = true;
      await this.$axios
        .post(this.env.billdesk_url, this.getPaymentPayload())
        .then((res) => {
          if (res.status == 200) {
            const { rdata, bdorderid, order_id, ecom_order_id, order_ref_no } =
              res.data;
            const form = document.createElement("form");
            form.method = "POST";
            form.action = this.env.billdesk_sdk_url;
            form.style.display = "none";
            const inputs = {
              bdorderid,
              merchantid: this.env.merchantid,
              rdata,
            };
            Object.entries(inputs).forEach(([name, value]) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = name;
              input.value = value;
              form.appendChild(input);
            });
            document.body.appendChild(form);
            this.createBilldeskHistory(
              order_id,
              ecom_order_id,
              order_ref_no
            ).then(() => {
              this.loading = false;
              form.submit();
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: res.data.message,
              color: "error",
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            message: "Error in payment, Please try again",
            color: "error",
          });
        });
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Copied to clipboard",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("showSnackbar", {
            message: "Failed to copy",
            color: "error",
          });
        });
    },
    navigateToApplication() {
      this.$router.push({
        path: "/home",
        query: {
          application_id: this.form.application_id,
          dob: this.formatDateForDisplay,
        },
      });
    },
    downloadAsTextFile() {
      const data = this.payment_order_status;
      const form_data = this.form;

      const fileContent = `
Payment Summary
--------------------
Name: ${form_data.name}
Email: ${form_data.email}
Application ID: ${
        form_data.application_id === null ? "-" : form_data.application_id
      }
DOB: ${form_data.dob}
Mobile Number: ${form_data.mobile_no}
Program: ${this.program_name}

Payment Details
--------------------
Bank Ref. No: ${data.bank_ref_no}
Bank ID: ${data.bankid}
Charge Amount: ${data.charge_amount}
Mode: ${data.payment_method_type}
Transaction Status: ${data.transaction_error_desc}
Transaction ID: ${data.transactionid}
Transaction Date: ${data.transaction_date}
      `.trim();
      const blob = new Blob([fileContent], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${
        form_data.application_id ? form_data.application_id : form_data.name
      }_payment_details.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    formatDob() {
      const [year, month, day] = this.form.dob.split("-");
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
